/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Task_Transition_InvalidInputs */

const en_task_transition_invalid = /** @type {(inputs: Task_Transition_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This activity cannot make that transition.`)
};

const pt_br2_task_transition_invalid = /** @type {(inputs: Task_Transition_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esta atividade não pode realizar essa transição.`)
};

/**
* | output |
* | --- |
* | "This activity cannot make that transition." |
*
* @param {Task_Transition_InvalidInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const task_transition_invalid = /** @type {((inputs?: Task_Transition_InvalidInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Task_Transition_InvalidInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_task_transition_invalid(inputs)
	return pt_br2_task_transition_invalid(inputs)
});